import { useContext, useMemo } from "react"
import { DoughnutChartsContext } from "../DoughnutChartsContext"
import { prosodyLabels, ratingColors4, ratingListLabel5 } from "keys/rating"

const useCharts = () => {
    const { doughnutCharts, prosodyDoughnut, fluencyDoughnut, percentAccuracyDoughnut, factoredPercentAccuracyDoughnut, fluencyReadingDoughnut, correctWordsPerMinuteDoughnut } = useContext(DoughnutChartsContext)

    const charts = useMemo(
        () => [
            {
                label: "קצב",
                chartKey: "words_per_minute",
            },
            {
                label: "דיוק (גוֺלְמִי)",
                chartKey: "percent_accuracy"
            },
            {
                label: "דיוק (משוקלל)",
                chartKey: "factored_percent_accuracy"
            },
            {
                label: "רצף",
                chartKey: "fluency_reading"
            },
            {
                label: "מספר מילים נכונות לדקה",
                chartKey: "correct_words_per_minute"
            },
            {
                label: "פרוזודיה",
                chart: prosodyDoughnut,
                ratingLabels: prosodyLabels,
                ratingColors: [ratingColors4[1], ratingColors4[2], ratingColors4[4]]
            }
        ], [doughnutCharts, prosodyDoughnut, fluencyDoughnut, percentAccuracyDoughnut, factoredPercentAccuracyDoughnut, fluencyReadingDoughnut, correctWordsPerMinuteDoughnut]
    )

    return charts
}

export default useCharts